<template>
    <v-dialog
        v-model="$store.state.tracking.TrackingHrs"
        width="1200px"
        transition="dialog-transition"
    >
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >Tracking Hrs.</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$store.state.tracking.TrackingHrs = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-simple-table fixed-header height="700px" dense>
                    <tbody>
                        <tr v-for="(item, j) in data" :key="j">
                            <td style="width:60px;" :class="item.class">
                                {{ item.C1 }}
                            </td>
                            <template v-if="item.C1 === 'ShiftDetail:'">
                                <td class="R1RD" style="width:60px;">
                                    {{ item.C2 }}
                                </td>
                            </template>
                            <template v-else>
                                <td style="width:60px;" :class="item.class">
                                    {{ item.C2 }}
                                </td>
                            </template>
                            <td style="width:80px;" :class="item.class">
                                {{ item.C3 }}
                            </td>
                            <template v-if="item.C1 === 'ShiftDetail:'">
                                <td
                                    class="R1RD"
                                    colspan="2"
                                    style="width:320px;"
                                >
                                    {{ item.C4 }}
                                </td>
                            </template>
                            <template v-else>
                                <td style="width:200px;" :class="item.class">
                                    {{ item.C4 }}
                                </td>
                            </template>
                            <template v-if="item.C1 != 'ShiftDetail:'">
                                <td style="width:120px;" :class="item.class">
                                    {{ item.C5 }}
                                </td>
                            </template>
                            <td style="width:120px;" :class="item.class">
                                {{ item.C6 }}
                            </td>
                            <td style="width:120px;" :class="item.class">
                                {{ item.C7 }}
                            </td>
                            <td style="width:120px;" :class="item.class">
                                {{ item.C8 }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['ShiftId'],
    data: function() {
        return {
            data: []
        };
    },
    async mounted() {
        this.loadOrderCK(this.ShiftId);
    },
    methods: {
        loadOrderCK: function(ShiftId) {
            var str = this.$store;
            console.log(ShiftId);
            axios
                .get('shift-header/getTrackingHrs/' + this.ShiftId)
                .then(response => {
                    console.log(response, ShiftId);
                    this.data = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
<style scoped>
td {
    padding: 5px !important;
}
.R1 {
    background: #0b2161 !important;
}
.R1R {
    background: #0b2161 !important;
    color: #f5f6ce !important;
    font-size: small !important;
    text-align: right !important;
}
.R1RT {
    background: #0b2161 !important;
    color: #f5f6ce !important;
    font-size: small !important;
    text-align: right !important;
}
.R1RD {
    background: #ffffff !important;
    color: #0b2161 !important;
    font-size: small !important;
    text-align: left !important;
}
.R2 {
    background: #0174df !important;
    color: #f2f5a9 !important;
    font-size: small !important;
}
.R3 {
    background: #e6e6e6 !important;
    color: #000000 !important;
    font-size: small !important;
}
.R4 {
    background: #e0e6f8 !important;
    color: #000000 !important;
    font-size: small !important;
}
</style>
